import React, { memo } from 'react';

import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import { EmptyVisualization } from './EmptyVisualization/EmptyVisualization';
import { useVisualizationBlock } from './useVisualizationBlock';
import cls from './VisualizationBlock.module.css';
import { Carousel } from '../../../../components/newUI/Carousel/Carousel';
import { Icon } from '../../../../components/newUI/Icon/Icon';
import { PrevMedia } from '../../../../components/newUI/PrevMedia/PrevMedia';

interface VisualizationBlockProps {
    classes?: string;
}

export const VisualizationBlock = memo(({ classes }: VisualizationBlockProps) => {
    const {
        onEditVisualization,
        imagesSrc,
        mediaData,
        prevImageData,
        setCurrentIndex,
        setCurrentUrl,
        setCurrentMimeType,
        onHideModal,
        onShowPrevImage,
        is_customer,
        can_show_financial_info,
    } = useVisualizationBlock();

    return (
        <>
            {!!prevImageData.currentUrl && (
                <PrevMedia
                    currentIndex={prevImageData.currentIndex}
                    mediaDataList={mediaData}
                    setCurrentIndex={setCurrentIndex}
                    setCurrentUrl={setCurrentUrl}
                    setCurrentMimeType={setCurrentMimeType}
                    onHideModal={onHideModal}
                    currentUrl={prevImageData.currentUrl}
                    fileName=""
                    isImage
                    isNotSaving
                />
            )}
            <div className={classNames(cls.VisualizationBlock, [classes])}>
                <ReactTooltip
                    id="global-edit"
                    aria-haspopup="true"
                    effect="solid"
                    delayHide={200}
                    delayShow={200}
                    type="light"
                    className={cls.tooltip}
                >
                    <p>{i18next.t('VisualizationBlock.return.tooltip')}</p>
                </ReactTooltip>
                <div className={cls.header}>
                    <span>{i18next.t('VisualizationBlock.return.title')}</span>
                    {!is_customer && can_show_financial_info && (
                        <button
                            data-tip
                            data-for="global-edit"
                            type="button"
                            className={cls.button}
                            onClick={onEditVisualization}
                        >
                            <Icon iconName="editInformationBlock" />
                        </button>
                    )}
                </div>
                {imagesSrc.length ? (
                    <div className={cls.carouselWrapper}>
                        <Carousel images={imagesSrc} onShowPrevImage={onShowPrevImage} />
                    </div>
                ) : (
                    <EmptyVisualization />
                )}
            </div>
        </>
    );
});
